var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loggedIn)?_c('LoginForm'):_vm._e(),_c('br'),_c('Content',{attrs:{"name":"welcome"}}),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }